import { render, staticRenderFns } from "./PropertySelectMultiple.vue?vue&type=template&id=5444ef4b&"
import script from "./PropertySelectMultiple.vue?vue&type=script&lang=js&"
export * from "./PropertySelectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5444ef4b')) {
      api.createRecord('5444ef4b', component.options)
    } else {
      api.reload('5444ef4b', component.options)
    }
    module.hot.accept("./PropertySelectMultiple.vue?vue&type=template&id=5444ef4b&", function () {
      api.rerender('5444ef4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertySelectMultiple.vue"
export default component.exports